import moment from 'moment';

export const OUTPUT_DATE_FORMAT = 'DD MMM YYYY';

const format = 'D,D M,D MMM,D M YY,D MMM YY,D M YYYY,D MMM YYYY';
const allformats =
  format +
  ',' +
  format.replace(/ /g, '.') +
  ',' +
  format.replace(/ /g, '-') +
  ',' +
  format.replace(/ /g, '/') +
  ',DDMM,DDMMYY,DDMMYYYY,DD MMM YYYY,YYYY-MM-DD,YYYY-MM-DDTHH:mm:ss.SSS,YYYY-MM-DDTHH:mm:ss.SSSSSS,YYYY-MM-DDTHH:mm,ddd Do MMM YYYY HH:mm,ddd Do MMM YYYY';
export const parseFormats = allformats.split(',');

/**
 * @deprecated - Use date-fns please.
 */
export function jsr310ToText(jsr310, dateFormat = OUTPUT_DATE_FORMAT) {
  let date;
  date = moment(jsr310, 'YYYY-MM-DD', true);
  return date.isValid() ? date.format(dateFormat) : jsr310;
}

/**
 * @deprecated - Use date-fns please.
 */
export function formatDate(value, format = 'DD MMM YYYY') {
  if (!value) {
    return null;
  }

  if (!(value instanceof Date)) value = new Date(value);
  let date;
  date = moment(value, 'YYYY-MM-DD', true);
  return date.isValid() ? date.format(format) : null;
}

/**
 * @deprecated - Use date-fns please.
 */
export function formatServicesDate(value) {
  return value.isValid() ? value.format('YYYY-MM-DD') : null;
}

/**
 * @deprecated - Use date-fns please.
 */
export function formatDateTime(value) {
  let date;
  date = moment(value);
  return date.isValid() ? date.format('DD MMM YYYY HH:mm') : value;
}

/**
 * @deprecated - Use date-fns please.
 */
export function createDate(value) {
  return moment(value, parseFormats, true);
}

/**
 * @deprecated - Use date-fns please.
 */
export function todaysDate(format = 'YYYY-MM-DD') {
  return moment().format(format);
}
